import { KeyValue } from '@angular/common';
import {
	Component,
	ElementRef,
	HostBinding,
	Input,
	OnDestroy,
	OnInit,
} from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { EVENTS, FORM_NAMES, FORM_FIELD_TYPES } from '@constants/analytics';
import { AnalyticsService } from '@services/analytics.service';

@Component({
	selector: 'qe-age-select-menu',
	templateUrl: './age-select-menu.component.html',
	styleUrls: ['./age-select-menu.component.scss'],
})
export class AgeSelectMenuComponent implements OnInit, OnDestroy {
	@HostBinding('class.select-menu') public klassName = true;
	@Input() optional: boolean = false;
	@Input() options: Array<KeyValue<number, string>> = [];
	@Input() formGroup!: FormGroup | AbstractControl | null;
	@Input() value!: number | undefined;
	public selectedOption: string | number | undefined = '';
	public toggleOptions: boolean = false;
	public isFocused: boolean = false;

	constructor(
		private readonly elementRef: ElementRef,
		private readonly gtmService: AnalyticsService,
	) {}

	ngOnInit(): void {
		this.addOutsideClickListener();

		// eslint-disable-next-line eqeqeq
		if (this.value != null) {
			if (this.value === Number('999')) {
				this.selectedOption = '0 - 6 weeks old';
			} else {
				this.selectedOption = this.options.find(op => op.key === this.value)?.value ?? '';
			}
			this.isFocused = true;
		}
	}

	ngOnDestroy(): void {
		this.removeOutsideClickListener();
	}

	public onFocus(): void {
		this.toggleOptions = !this.toggleOptions;
		this.isFocused = true;
	}

	public onOptionChange(option: KeyValue<number | string, string>): void {
		// HACK: This is a hacky way to handle '0-6 weeks old' age select option and throw associated error
		if (option.key === Number('999')) {
			this.formGroup?.patchValue({ age: '999' });
		} else {
			this.formGroup?.patchValue({ age: option.key });
		}

		this.selectedOption = option.value;
		this.toggleOptions = false;

		this.gtmService.push({
			event: EVENTS.FORM_FIELD,
			form_name: FORM_NAMES.PET_INFO,
			field_name: 'age',
			field_value: this.selectedOption,
			field_type: FORM_FIELD_TYPES.SELECT,
			field_id: `${FORM_FIELD_TYPES.SELECT}-${FORM_NAMES.PET_INFO}-age`
		});
	}

	public addOutsideClickListener(): void {
		this.onClickOutside = (event: MouseEvent): void => {
			if (!this.isClickInsideComponent(event)) {
				this.toggleOptions = false;
				this.isFocused = !!this.selectedOption;
			}
		};

		document.addEventListener('click', this.onClickOutside);
	}

	public removeOutsideClickListener(): void {
		document.removeEventListener('click', this.onClickOutside);
	}

	private isClickInsideComponent(event: MouseEvent): boolean {
		const element = event.target as HTMLElement;

		return this.elementRef.nativeElement.contains(element);
	}

	private onClickOutside: (event: MouseEvent) => void = () => null;
}
